/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_PaidInputs */

const vi_order_paid = /** @type {(inputs: Order_PaidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thanh toán`)
};

/**

* @param {Order_PaidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_paid = /** @type {((inputs?: Order_PaidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_PaidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_paid(inputs)
});